// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"1eee581c","833":"92c5b7e4"}[chunkId] + ".chunk.js";
};